import { call, takeEvery, put } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import { fetchDocumentMeta } from 'sagas/documentMeta';
import { GET_DOCUMENT_DATA } from 'actions/documentMeta/types';
import { fetchAssessmentAction } from 'actions/assessment';

export function* getDocumentData(action: AnyAction) {
  yield call(fetchDocumentMeta, action);
  yield put(fetchAssessmentAction(action.documentId, action.documentVersion));
}

export default function* watchGetDocumentData() {
  yield takeEvery(GET_DOCUMENT_DATA, getDocumentData);
}
